import * as React from 'react'
import { SVGProps } from 'react'

const SvgBitcoinLargeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path fill='inherit' d='M0 0h24v24H0z' />
    <path
      d='M23.641 14.903c-1.603 6.428-8.115 10.34-14.545 8.738C2.67 22.038-1.244 15.527.36 9.098 1.962 2.67 8.473-1.244 14.902.36c6.43 1.603 10.342 8.115 8.739 14.544Z'
      fill='#F7931A'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.009 10.283c.235-1.596-.962-2.453-2.597-3.026l.53-2.161-1.295-.328-.516 2.104c-.34-.086-.69-.167-1.038-.248l.52-2.118-1.294-.328-.531 2.16c-.282-.064-.559-.129-.827-.197l.001-.007-1.786-.453-.345 1.406s.961.224.941.237c.525.133.62.486.604.766l-.605 2.462c.036.01.083.023.135.044l-.038-.01-.099-.024-.847 3.45c-.064.162-.227.404-.594.312.013.02-.941-.238-.941-.238l-.643 1.506 1.686.427c.184.047.367.095.547.143l.376.099-.536 2.186 1.294.328.53-2.163c.354.097.697.187 1.033.272l-.529 2.153 1.295.328.536-2.182c2.21.424 3.87.253 4.57-1.777.563-1.633-.029-2.576-1.19-3.19.845-.199 1.483-.764 1.653-1.933Zm-2.96 4.216c-.367 1.5-2.677.88-3.734.596l-.253-.067.712-2.896c.088.022.196.047.318.074 1.093.25 3.333.76 2.957 2.293Zm-2.738-3.637c.882.239 2.804.76 3.139-.603.341-1.393-1.527-1.813-2.439-2.018a11.137 11.137 0 0 1-.267-.063l-.645 2.627.212.057Z'
      fill='#fff'
    />
  </svg>
)

export default SvgBitcoinLargeIcon
